module.exports = __webpack_public_path__ + "img/idea2_b.e8ea233a.svg";